import { render, staticRenderFns } from "./AddAttributeColumnDialog.vue?vue&type=template&id=0202e2c9&"
import script from "./AddAttributeColumnDialog.vue?vue&type=script&lang=js&"
export * from "./AddAttributeColumnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports